import { Injectable } from '@nestjs/common';
import { AntibioticsIdentifiedFarmer, AntibioticsTestStatus, ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { RmAntiBioticsRepository } from '../rm-antibiotics-report.respository';
import { RmAntiBioticsAdapter } from '../dto/rm-antibiotics-report.adapter';
import { RmAntibioticsReportInfo } from '../dto/rm-antibiotics-report.dto';
import { Grn } from '../raw-material-grn.entity';
import { GrnItems } from '../raw-material-grn-items.entity';
import { LotCodeOpsService } from '@gtpl/shared-services/production';
import {LotCodeOpsEntity} from '../../../../../../services/production/src/app/operations-track/entities/lot-code.entity'
import appSettings from 'apps/services/config';
import { getConnection, getManager, QueryRunner } from 'typeorm';
import { AntibioticsReq } from './rm-antibiotics-req';
import { RmAntiBioticsTest } from '../rm-antibiotics-report.entity';
import { RejectedIndentReq } from './indent-reject-req';
@Injectable()
export class AntibioticsReportService {
    constructor(
        private repository: RmAntiBioticsRepository,
        private adapter: RmAntiBioticsAdapter
    ){} 

    // async createAntiBioticsTest(info: any): Promise<CommonResponse>{
    //     const manager = new GenericTransactionManager();
    //     try{
    //         await manager.startTransaction();
    //         const convertedEntity = await this.adapter.convertDtoToEntity(info);
    //         const savedInfo = await manager.getCustomRepository(RmAntiBioticsRepository).save(convertedEntity);

    //         if(savedInfo){
    //             const updateGrn = await manager.getRepository(GrnItems).update({ grnItemId: savedInfo.grnItemId }, { isAntibioticsTestCompleted: true });
    //             if(updateGrn.affected){
    //                 manager.completeTransaction();
    //                 return new CommonResponse(true, 1111, 'Rm Antibiotics Testing Info updated successfully')
    //             }else {
    //                 throw new ErrorResponse(9999, 'Failed to update RM GRN');
    //             }
    //         }else {
    //             throw new ErrorResponse(9999, 'Failed to Create Details');
    //         }
    //     }catch(error) {
    //         manager.releaseTransaction();
    //         return error;
    //     }
    // }

    
async createAntiBioticsTest(info: any): Promise<CommonResponse> {
    console.log('req',info)
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();

    try {
        await transManager.startTransaction();
console.log('grnitemid',info.grnitemid)
        let existingRecord = await transManager.manager.findOne(RmAntiBioticsTest, {
            where: { grnItemId: info.grnItemId,qcAt:info.qcAt }
        });


        const testFields = ['AHD', 'AMOZ', 'AOZ', 'CAP', 'SEM'];

        let allFieldsFilled = testFields.every(field => 
            info[field] !== undefined && info[field] !== null && info[field] !== ''
        );

        let overallTestResult = null;

        if (allFieldsFilled) {
            if (info['AHD'] === 'FAIL' || info['AMOZ'] === 'FAIL' || info['AOZ'] === 'FAIL' || 
                info['CAP'] === 'FAIL' || info['SEM'] === 'FAIL') {
                overallTestResult = 'FAIL';
            } else {
                overallTestResult = 'PASS';
            }
        }

        if (existingRecord) {
            const updatedFields = [
                'AHD', 'AMOZ', 'AOZ', 'CAP', 'SEM', 'labName', 'location', 'allotedLab',
                'samplerName', 'remarks', 'capDetails', 'aozDetails', 'amozDetails',
                'ahdDetails', 'semDetails'
            ];

            updatedFields.forEach(field => {
                if (info[field] !== undefined) {
                    (existingRecord as any)[field] = info[field];
                }
            });

            existingRecord.antibioticsTestStatus = allFieldsFilled
            ? AntibioticsTestStatus.COMPLETED
            : AntibioticsTestStatus.PROCESSING;

        await transManager.manager.update(RmAntiBioticsTest, { grnItemId: info.grnItemId,qcAt:info.qcAt }, existingRecord);
    } else {
        // Create a new record if it doesn't exist
        existingRecord = transManager.manager.create(RmAntiBioticsTest, { ...info,qcAt: info.qcAt, antibioticsTestStatus: allFieldsFilled ? AntibioticsTestStatus.COMPLETED : AntibioticsTestStatus.PROCESSING });

        await transManager.manager.save(RmAntiBioticsTest, existingRecord);
    }

    if (info.qcAt === 'GRADING') {
        await transManager.query(`
            UPDATE ${appSettings.production_db}.grade_inventory 
            SET antibiotics_test_status = '${existingRecord.antibioticsTestStatus}'
            WHERE lot_number = '${info.lotNumber}' AND grn_hon_count = ${info.count}
        `);
    } else if (info.qcAt === 'PRE HARVEST') {
        await transManager.query(`
            UPDATE ${appSettings.rm_procure_db}.grn_items 
            SET antibiotics_test_status = '${existingRecord.antibioticsTestStatus}'
            WHERE grn_item_id = ${info.grnItemId}
        `);
    }
        const updateGrn = await transManager.manager.update(
            GrnItems,
            { grnItemId: info.grnItemId },
            { isAntibioticsTestCompleted: allFieldsFilled }
        );

        if (!updateGrn.affected) {
            throw new Error('Failed to update RM GRN');
        }

        const lotCodeOpsData = {
            lotNumber: info.lotNumber,
            count:info.count,
            testResult: overallTestResult,
            grnId: info.grnId,
            grnItemId: info.grnItemId,
            indentId:info.indentId,
            indentItemId:info.indentItemId
        };

        if (allFieldsFilled) {
            const antiBiotics = `
            UPDATE ${appSettings.rm_procure_db}.rm_antibiotics_info ai 
            SET test_result = ?
            WHERE grn_item_id = ?
            `;
            await transManager.query(antiBiotics, [lotCodeOpsData.testResult, lotCodeOpsData.grnItemId])
            if(info.qcAt === 'GRADING') {
                const gradeInventoryUpdateQuery = `
                UPDATE ${appSettings.production_db}.grade_inventory
                SET test_result = ?
                WHERE lot_number = ? AND grn_hon_count = ?`;

                await transManager.query(gradeInventoryUpdateQuery, [lotCodeOpsData.testResult, lotCodeOpsData.lotNumber,lotCodeOpsData.count]);
            }
            
            if(info.qcAt === 'PRE HARVEST') {
                const grnItemUpdateQuery = `
                UPDATE ${appSettings.rm_procure_db}.grn_items
                SET test_result = ?
                WHERE grn_item_id = ?`;

            const testResultValue = lotCodeOpsData.testResult === 'PASS' ? 'PASS' : 'FAIL';

            await transManager.query(grnItemUpdateQuery, [testResultValue, lotCodeOpsData.grnItemId]);

                

            const lotCodeUpdateQuery = `
                UPDATE ${appSettings.production_db}.lot_code_data
                SET grading_test_result = ?
                WHERE lot_number = ?`;

            await transManager.query(lotCodeUpdateQuery, [lotCodeOpsData.testResult, lotCodeOpsData.lotNumber]);
            }
            
            const supplierdata = `
            SELECT ii.broker, ii.farmer
            FROM ${appSettings.rm_procure_db}.indent i
            LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_id = i.indent_id
            WHERE i.indent_id = ? 
            LIMIT 1
        `;
        const supplierInfo = await transManager.query(supplierdata, [lotCodeOpsData.indentId]);

        const failCount = await transManager.query(
            `SELECT COUNT(*) AS count 
             FROM ${appSettings.rm_procure_db}.rm_antibiotics_info 
             WHERE indent_id = ? AND test_result = 'FAIL'`,
            [lotCodeOpsData.indentId]
        );

        if (supplierInfo && supplierInfo.length > 0) {
            const { broker, farmer } = supplierInfo[0];
            const supplierId = broker !== 0 ? broker : farmer;

            if (supplierId !== 0) {
                const finalStatus = failCount[0]?.count > 0
                    ? AntibioticsIdentifiedFarmer.REJECTED
                    : AntibioticsIdentifiedFarmer.APPROVED;

                await transManager.query(
                    `UPDATE ${appSettings.masters_db}.suppliers
                     SET a_b_identified_farmer = ?
                     WHERE supplier_id = ?`,
                    [finalStatus, supplierId]
                );
            }
        }
    }

        await transManager.commitTransaction();
        return new CommonResponse(true, 1111, 'Rm Antibiotics Testing Info updated successfully');
    } catch (error) {
        await transManager.rollbackTransaction();
        return new CommonResponse(false, 9999, error.message || 'An error occurred while processing the request');
    } finally {
        await transManager.release();
    }
}


    // async createAntiBioticsTest(info: any): Promise<CommonResponse> {
    //     console.log('Request received:', info);
    //     const connection = getConnection();
    //     const transManager: QueryRunner = connection.createQueryRunner();
    
    //     try {
    //         await transManager.startTransaction();
    //         console.log('GRN Item ID:', info.grnItemId);
    
    //         let existingRecord: RmAntiBioticsTest | null = null;
    
    //         // Check for existing record based on `qcAt` type
    //         if (info.qcAt === 'GRADING') {
    //             existingRecord = await transManager.manager.findOne(RmAntiBioticsTest, {
    //                 where: { grnItemId: info.grnItemId }
    //             });
    //         } else if (info.qcAt === 'PRE HARVEST') {
    //             existingRecord = await transManager.manager.findOne(RmAntiBioticsTest, {
    //                 where: { indentItemId: info.indentItemId }
    //             });
    //         }
    
    //         const testFields = ['AHD', 'AMOZ', 'AOZ', 'CAP', 'SEM'];
    
    //         // Check if all fields are filled
    //         const allFieldsFilled = testFields.every(field => 
    //             info[field] !== undefined && info[field] !== null && info[field] !== ''
    //         );
    
    //         // Determine overall test result
    //         const overallTestResult = testFields.some(field => info[field] === 'FAIL') ? 'FAIL' : 'PASS';
    
    //         if (existingRecord) {
    //             // Fields to update in the existing record
    //             const updatedFields = [
    //                 'AHD', 'AMOZ', 'AOZ', 'CAP', 'SEM', 'labName', 'location', 'allotedLab',
    //                 'samplerName', 'remarks', 'capDetails', 'aozDetails', 'amozDetails',
    //                 'ahdDetails', 'semDetails'
    //             ];
    
    //             updatedFields.forEach(field => {
    //                 if (info[field] !== undefined) {
    //                     (existingRecord as any)[field] = info[field];
    //                 }
    //             });
    
    //             existingRecord.antibioticsTestStatus = allFieldsFilled
    //                 ? AntibioticsTestStatus.COMPLETED
    //                 : AntibioticsTestStatus.PROCESSING;
    
    //             if (info.qcAt === 'GRADING') {
    //                 await transManager.manager.update(RmAntiBioticsTest, { grnItemId: info.grnItemId }, existingRecord);
    //             } else if (info.qcAt === 'PRE HARVEST') {
    //                 await transManager.manager.update(RmAntiBioticsTest, { indentItemId: info.indentItemId }, existingRecord);
    //             }
    //         } else {
    //             // Create a new record if it doesn't exist
    //             existingRecord = transManager.manager.create(RmAntiBioticsTest, {
    //                 ...info,
    //                 qcAt: info.qcAt,
    //                 grnId: info.qcAt === 'GRADING' ? info.grnId : null,
    //                 grnItemId: info.qcAt === 'GRADING' ? info.grnItemId : null,
    //                 indentItemId:info.qcAt ==='PRE HARVEST'? info.indentItemId : null,
    //                 indentId:info.qcAt ==='PRE HARVEST'? info.indentId : null,
    //                 antibioticsTestStatus: allFieldsFilled ? AntibioticsTestStatus.COMPLETED : AntibioticsTestStatus.PROCESSING
    //             });
    
    //             await transManager.manager.save(RmAntiBioticsTest, existingRecord);
    //         }
    
    //         // Update external databases based on `qcAt`
    //         if (info.qcAt === 'GRADING') {
    //             await transManager.query(`
    //                 UPDATE ${appSettings.production_db}.grade_inventory 
    //                 SET antibiotics_test_status = '${existingRecord.antibioticsTestStatus}'
    //                 WHERE lot_number = '${info.lotNumber}' AND grn_hon_count = ${info.count}
    //             `);
    //         } else if (info.qcAt === 'PRE HARVEST') {
    //             await transManager.query(`
    //                 UPDATE ${appSettings.rm_procure_db}.indent_items 
    //                 SET antibiotics_test_status = '${existingRecord.antibioticsTestStatus}'
    //                 WHERE indent_item_id = ${info.indentItemId}
    //             `);
    //         }
    
    //         if (allFieldsFilled) {
    //             if (info.qcAt === 'GRADING') {
    //                 await transManager.query(
    //                     `UPDATE ${appSettings.production_db}.grade_inventory
    //                      SET test_result = ?
    //                      WHERE lot_number = ? AND grn_hon_count = ?`,
    //                     [overallTestResult, info.lotNumber, info.count]
    //                 );
            
    //                 await transManager.query(
    //                     `UPDATE ${appSettings.rm_procure_db}.rm_antibiotics_info
    //                      SET test_result = ?
    //                      WHERE grn_item_id = ?`,
    //                     [overallTestResult, info.grnItemId]
    //                 );
    //             } else if (info.qcAt === 'PRE HARVEST') {
    //                 await transManager.query(
    //                     `UPDATE ${appSettings.rm_procure_db}.rm_antibiotics_info
    //                      SET test_result = ?
    //                      WHERE indent_item_id = ?`,
    //                     [overallTestResult, info.indentItemId]
    //                 );
            
    //                 await transManager.query(
    //                     `UPDATE ${appSettings.rm_procure_db}.indent_items
    //                      SET test_result = ?
    //                      WHERE indent_item_id = ?`,
    //                     [overallTestResult, info.indentItemId]
    //                 );
            
    //                 await transManager.query(
    //                     `UPDATE ${appSettings.production_db}.lot_code_data
    //                      SET grading_test_result = ?
    //                      WHERE lot_number = ?`,
    //                     [overallTestResult, info.lotNumber]
    //                 );
    //             }
    //         }
            
    
    //         await transManager.commitTransaction();
    //         return new CommonResponse(true, 1111, 'Rm Antibiotics Testing Info updated successfully');
    //     } catch (error) {
    //         await transManager.rollbackTransaction();
    //         console.error('Error:', error);
    //         return new CommonResponse(false, 9999, error.message || 'An error occurred while processing the request');
    //     } finally {
    //         await transManager.release();
    //     }
    // }

    
  async revertAntiBioticsTestStatus(req: { grnItemId: number, qcAt: string, lotNumber?: string }): Promise<CommonResponse> {
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();

    try {
        await transManager.startTransaction();

        const existingRecord = await transManager.manager.findOne(RmAntiBioticsTest, {
            where: { grnItemId: req.grnItemId, qcAt: req.qcAt }
        });

        if (!existingRecord || existingRecord.antibioticsTestStatus !== AntibioticsTestStatus.COMPLETED) {
            throw new Error("Record not found or not in COMPLETED status");
        }

        existingRecord.antibioticsTestStatus = AntibioticsTestStatus.PROCESSING;

        await transManager.manager.update(RmAntiBioticsTest, 
            { grnItemId: req.grnItemId, qcAt: req.qcAt }, 
            existingRecord
        );

        // if (req.qcAt === 'GRADING' && req.lotNumber) {
        //     await transManager.query(`
        //         UPDATE ${appSettings.production_db}.grade_inventory 
        //         SET antibiotics_test_status = 'PROCESSING'
        //         WHERE lot_number = '${req.lotNumber}'
        //     `);
        // } 
         if (req.qcAt === 'PRE HARVEST') {
            await transManager.query(`
                UPDATE ${appSettings.rm_procure_db}.grn_items 
                SET antibiotics_test_status = 'PROCESSING'
                WHERE grn_item_id = ${req.grnItemId}
            `);
        }

        await transManager.commitTransaction();
        return new CommonResponse(true, 1111, 'Status reverted to PROCESSING successfully');
    } catch (error) {
        await transManager.rollbackTransaction();
        return new CommonResponse(false, 9999, error.message || 'Failed to revert status');
    } finally {
        await transManager.release();
    }
}
    
    
    async updateAntiBioticTest(info: any): Promise<CommonResponse> {
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();
    
    try {
        await transManager.startTransaction();

        const existingRecord = await transManager.manager.findOne(RmAntiBioticsTest, { where: { grnItemId: info.grnItemId } });

        if (!existingRecord) {
            throw new ErrorResponse(9999, 'Record not found');
        }

        const updatedFields = ['AHD', 'AMOZ', 'AOZ', 'CAP', 'SEM'];
        updatedFields.forEach(field => {
            if (info[field] !== undefined) {
                (existingRecord as any)[field] = info[field];
            }
        });
        const allFieldsProvided = updatedFields.every(field => existingRecord[field] !== undefined);
        existingRecord.testStatus = allFieldsProvided ? true : false;
        if (info.labName !== undefined) {
            existingRecord.labName = info.labName;
        }

        await transManager.manager.save(RmAntiBioticsTest, existingRecord);

        await transManager.commitTransaction();
        await transManager.release();

        return new CommonResponse(true, 1111, 'Rm Antibiotics Testing Info updated successfully');
    } catch (error) {
        await transManager.rollbackTransaction();
        await transManager.release();
        return error;
    }
}

    
    

// async createAntiBioticsTest(info: any): Promise<CommonResponse> {
//     const manager = new GenericTransactionManager();
//     const queryRunner = getManager();
//     const MAX_RETRIES = 3; // Retry up to 3 times in case of lock wait timeout
//     let retryCount = 0;

//     try {
//         await manager.startTransaction();

//         // Convert DTO to Antibiotics Test entity
//         const convertedEntity = await this.adapter.convertDtoToEntity(info);

//         // Save Antibiotics Test info
//         const savedInfo = await manager.getCustomRepository(RmAntiBioticsRepository).save(convertedEntity);
//         console.log(savedInfo.overAll, 'backend1');

//         if (savedInfo) {
//             // Update related GRN item
//             const updateGrn = await manager.getRepository(GrnItems).update(
//                 { grnItemId: savedInfo.grnItemId },
//                 { isAntibioticsTestCompleted: true }
//             );

//             if (updateGrn.affected) {
//                 const lotCodeOpsData = {
//                     lotNumber: savedInfo.lotNumber,
//                     testResult: savedInfo.overAll,
//                     grnId: savedInfo.grnId,
//                     grnItemId: savedInfo.grnItemId
//                 };

//                 const grnUpdateQuery = `
//                     UPDATE ${appSettings.rm_procure_db}.grn
//                     SET test_result = ?
//                     WHERE grn_id = ?`;

//                 const gradeInventoryUpdateQuery = `
//                     UPDATE ${appSettings.production_db}.grade_inventory
//                     SET test_result = ?
//                     WHERE lot_number = ?`;

//                 const grnItemUpdateQuery = `
//                     UPDATE ${appSettings.rm_procure_db}.grn_items
//                     SET test_result = ?
//                     WHERE grn_item_id = ?`;

//                 // Retry logic for executing queries
//                 while (retryCount < MAX_RETRIES) {
//                     try {
//                         await queryRunner.query(grnUpdateQuery, [lotCodeOpsData.testResult, lotCodeOpsData.grnId]);
//                         await queryRunner.query(gradeInventoryUpdateQuery, [lotCodeOpsData.testResult, lotCodeOpsData.lotNumber]);
//                         await queryRunner.query(grnItemUpdateQuery, [lotCodeOpsData.testResult, lotCodeOpsData.grnItemId]);

//                         manager.completeTransaction();
//                         return new CommonResponse(true, 1111, 'Rm Antibiotics Testing Info updated successfully');
//                     } catch (error) {
//                         if (error.code === 'ER_LOCK_WAIT_TIMEOUT') {
//                             retryCount++;
//                             console.log(`Retrying transaction... (${retryCount}/${MAX_RETRIES})`);
//                             continue;
//                         } else {
//                             throw error;
//                         }
//                     }
//                 }

//                 throw new ErrorResponse(9999, 'Failed to update Rm Antibiotics Testing after retries');
//             } else {
//                 manager.releaseTransaction();
//                 throw new ErrorResponse(9999, 'Failed to update RM GRN');
//             }
//         } else {
//             manager.releaseTransaction();
//             throw new ErrorResponse(9999, 'Failed to Create Details');
//         }
//     } catch (error) {
//         await manager.releaseTransaction(); // Ensure transaction is rolled back on error
//         console.error('Error:', error);
//         throw error;
//     }
// }

// async getAllAntiBioticsRejectedIndentsData(req:RejectedIndentReq): Promise<CommonResponse> {
    
//     const manager = getManager();
//     req = req || {};
//         let query = `
//         SELECT 
//             an.test_result as overallResult, an.lot_number AS lotNumber, an.count, an.no_of_boxes AS boxes, 
//             an.c_a_p AS cap, an.c_a_p_details AS capValue, r1.reasons_name AS capReason, 
//             an.a_o_z AS aoz, an.a_o_z_details AS aozValue, r2.reasons_name AS aozReason, 
//             an.a_m_o_z AS amoz, an.a_m_o_z_details AS amozValue, r3.reasons_name AS amozReason, 
//             an.s_e_m AS sem, an.s_e_m_details AS semValue, r4.reasons_name AS semReason, 
//             an.a_h_d AS ahd, an.a_h_d_details AS ahdValue, r5.reasons_name AS ahdReason, 
//             an.grn_item_id AS grnItemId,an.test_at as testType,
//             CASE 
//                 WHEN an.test_at = 'GRADING' THEN gi.reweighment_quantity
//                 WHEN an.test_at = 'PRE HARVEST' THEN gi.quantity 
//                 ELSE NULL 
//             END AS quantity, g.grn_id as grnId,
//             g.grn_number AS grnNumber, g.grn_date AS grnDate, i.indent_date as indentDate,
//             i.indent_code AS indentNumber, i.indent_id AS indentId, i.supplier_type AS supplierType, 
//             an.alloted_lab AS allotedLab,  s.name AS farmerName, su.name AS dealerName
//         FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
//         LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
//         LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
//         LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
//         LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer 
//         LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.broker 
//         LEFT JOIN ${appSettings.masters_db}.reasons r1 ON r1.reasons_id = an.c_a_p_details
//         LEFT JOIN ${appSettings.masters_db}.reasons r2 ON r2.reasons_id = an.a_o_z_details
//         LEFT JOIN ${appSettings.masters_db}.reasons r3 ON r3.reasons_id = an.a_m_o_z_details
//         LEFT JOIN ${appSettings.masters_db}.reasons r4 ON r4.reasons_id = an.s_e_m_details
//         LEFT JOIN ${appSettings.masters_db}.reasons r5 ON r5.reasons_id = an.a_h_d_details
//         WHERE an.test_at IN ('GRADING', 'PRE HARVEST')
//         AND an.antibiotics_test_status = 'COMPLETED'
//         AND an.test_result = 'FAIL'
//         AND g.grn_date >= '2025-03-15'
//         `
//         if (req.grnFromDate && req.grnToDate != undefined) {
//             query += ` AND g.grn_date BETWEEN '${req.grnFromDate} 00:00:00' AND '${req.grnToDate} 23:59:59'`;
//         }
//         if (req.indentFromdate && req.indentToDate != undefined) {
//             query += ` AND i.indent_date BETWEEN '${req.indentFromdate} 00:00:00' AND '${req.indentToDate} 23:59:59'`;
//         }
//         if(req.indentNumber){
//             query += ` And i.indent_id = '${req.indentNumber}'`
//         }
//         if(req.grnNumber){
//             query += ` And g.grn_id = '${req.grnNumber}'`
//         }
//         if(req.count){
//             query += ` And an.count = '${req.count}'`
//         }
//         if (req.farmer) {
//             query += ` AND (s.name = '${req.farmer}' OR su.name = '${req.farmer}')`;
//         }
//         if (req.testAt) {
//             query += ` And an.test_at = '${req.testAt}'`
//         }
        
//   try {
//     const grnData = await manager.query(query);
//     return new CommonResponse(true, 1001, ' data retrieved successfully', grnData);
//   } catch (error) {
//     console.error("Database query error:", error);
//     return new CommonResponse(false, 1002, 'Error retrieving  data', []);
//   }
// }

async getAllAntiBioticsRejectedIndentsData(req:RejectedIndentReq): Promise<CommonResponse> {
    
    const manager = getManager();
    req = req || {};
        let query = `
        SELECT 
            an.test_result as overallResult, an.lot_number AS lotNumber, an.count, an.no_of_boxes AS boxes, 
            an.c_a_p AS cap, an.c_a_p_details AS capValue, r1.reasons_name AS capReason, 
            an.a_o_z AS aoz, an.a_o_z_details AS aozValue, r2.reasons_name AS aozReason, 
            an.a_m_o_z AS amoz, an.a_m_o_z_details AS amozValue, r3.reasons_name AS amozReason, 
            an.s_e_m AS sem, an.s_e_m_details AS semValue, r4.reasons_name AS semReason, 
            an.a_h_d AS ahd, an.a_h_d_details AS ahdValue, r5.reasons_name AS ahdReason, 
            ii.expected_qty as indentQuantity,gi.quantity AS grnQuantity,
            an.grn_item_id AS grnItemId,an.test_at as testType,
            CASE 
                WHEN an.test_at = 'GRADING' THEN gim.grn_hon_quantity 
                ELSE NULL 
            END AS HONQuantity, g.grn_id as grnId,
            g.grn_number AS grnNumber, g.grn_date AS grnDate, i.indent_date as indentDate,
            i.indent_code AS indentNumber, i.indent_id AS indentId, i.supplier_type AS supplierType, 
            an.alloted_lab AS allotedLab,  s.name AS farmerName, su.name AS dealerName
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
       LEFT JOIN  ${appSettings.production_db}.grade_inventory gim ON gim.lot_number = gi.plant_lot_number
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id = gi.indent_item_id
        LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer 
        LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.broker 
        LEFT JOIN ${appSettings.masters_db}.reasons r1 ON r1.reasons_id = an.c_a_p_details
        LEFT JOIN ${appSettings.masters_db}.reasons r2 ON r2.reasons_id = an.a_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r3 ON r3.reasons_id = an.a_m_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r4 ON r4.reasons_id = an.s_e_m_details
        LEFT JOIN ${appSettings.masters_db}.reasons r5 ON r5.reasons_id = an.a_h_d_details
        WHERE an.test_at IN ('GRADING', 'PRE HARVEST')
        AND an.antibiotics_test_status = 'COMPLETED'
        AND an.test_result = 'FAIL'
        AND g.grn_date >= '2025-03-15'
        `
        if (req.grnFromDate && req.grnToDate != undefined) {
            query += ` AND g.grn_date BETWEEN '${req.grnFromDate} 00:00:00' AND '${req.grnToDate} 23:59:59'`;
        }
        if (req.indentFromdate && req.indentToDate != undefined) {
            query += ` AND i.indent_date BETWEEN '${req.indentFromdate} 00:00:00' AND '${req.indentToDate} 23:59:59'`;
        }
        if(req.indentNumber){
            query += ` And i.indent_id = '${req.indentNumber}'`
        }
        if(req.grnNumber){
            query += ` And g.grn_id = '${req.grnNumber}'`
        }
        if(req.count){
            query += ` And an.count = '${req.count}'`
        }
        if (req.farmer) {
            query += ` AND (s.name = '${req.farmer}' OR su.name = '${req.farmer}')`;
        }
        if (req.testAt) {
            query += ` And an.test_at = '${req.testAt}'`
        }
         query += `
        GROUP BY 
            an.grn_item_id, an.test_result, an.lot_number, an.count, an.no_of_boxes, 
            an.c_a_p, an.c_a_p_details, r1.reasons_name, 
            an.a_o_z, an.a_o_z_details, r2.reasons_name, 
            an.a_m_o_z, an.a_m_o_z_details, r3.reasons_name, 
            an.s_e_m, an.s_e_m_details, r4.reasons_name, 
            an.a_h_d, an.a_h_d_details, r5.reasons_name, 
            an.test_at, gim.grn_hon_quantity, gi.quantity, 
            g.grn_id, g.grn_number, g.grn_date, 
            i.indent_date, i.indent_code, i.indent_id, i.supplier_type, 
            an.alloted_lab, s.name, su.name
    `;
  try {
    const grnData = await manager.query(query);
    return new CommonResponse(true, 1001, ' data retrieved successfully', grnData);
  } catch (error) {
    console.error("Database query error:", error);
    return new CommonResponse(false, 1002, 'Error retrieving  data', []);
  }
}

async getAllAntiBioticsFailedIndentsNumbers(): Promise<CommonResponse> {
    
    const manager = getManager();
        let query = `
        SELECT 
            
            i.indent_code AS indentNumber, i.indent_id AS indentId
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer 
        LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.broker 
        LEFT JOIN ${appSettings.masters_db}.reasons r1 ON r1.reasons_id = an.c_a_p_details
        LEFT JOIN ${appSettings.masters_db}.reasons r2 ON r2.reasons_id = an.a_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r3 ON r3.reasons_id = an.a_m_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r4 ON r4.reasons_id = an.s_e_m_details
        LEFT JOIN ${appSettings.masters_db}.reasons r5 ON r5.reasons_id = an.a_h_d_details
        WHERE an.test_at IN ('GRADING', 'PRE HARVEST')
        AND an.antibiotics_test_status = 'COMPLETED'
        AND an.test_result = 'FAIL'
        AND g.grn_date >= '2025-03-15'
        `
         query = query + `GROUP BY i.indent_id`
  try {
    const Data = await manager.query(query);
    return new CommonResponse(true, 1001, ' data retrieved successfully', Data);
  } catch (error) {
    console.error("Database query error:", error);
    return new CommonResponse(false, 1002, 'Error retrieving  data', []);
  }
}

async getAllAntiBioticsFailedGrnNumbers(): Promise<CommonResponse> {
    
    const manager = getManager();
        let query = `
        SELECT 
            
           g.grn_number AS grnNumber,g.grn_id as grnId
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer 
        LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.broker 
        LEFT JOIN ${appSettings.masters_db}.reasons r1 ON r1.reasons_id = an.c_a_p_details
        LEFT JOIN ${appSettings.masters_db}.reasons r2 ON r2.reasons_id = an.a_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r3 ON r3.reasons_id = an.a_m_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r4 ON r4.reasons_id = an.s_e_m_details
        LEFT JOIN ${appSettings.masters_db}.reasons r5 ON r5.reasons_id = an.a_h_d_details
        WHERE an.test_at IN ('GRADING', 'PRE HARVEST')
        AND an.antibiotics_test_status = 'COMPLETED'
        AND an.test_result = 'FAIL'
        AND g.grn_date >= '2025-03-15'
        `
         query = query + `GROUP BY g.grn_id`
  try {
    const Data = await manager.query(query);
    return new CommonResponse(true, 1001, ' data retrieved successfully', Data);
  } catch (error) {
    console.error("Database query error:", error);
    return new CommonResponse(false, 1002, 'Error retrieving  data', []);
  }
}

async getAllAntiBioticsFailedCount(): Promise<CommonResponse> {
    
    const manager = getManager();

        let query = `
        SELECT 
            
           an.count
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer 
        LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.broker 
        LEFT JOIN ${appSettings.masters_db}.reasons r1 ON r1.reasons_id = an.c_a_p_details
        LEFT JOIN ${appSettings.masters_db}.reasons r2 ON r2.reasons_id = an.a_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r3 ON r3.reasons_id = an.a_m_o_z_details
        LEFT JOIN ${appSettings.masters_db}.reasons r4 ON r4.reasons_id = an.s_e_m_details
        LEFT JOIN ${appSettings.masters_db}.reasons r5 ON r5.reasons_id = an.a_h_d_details
        WHERE an.test_at IN ('GRADING', 'PRE HARVEST')
        AND an.antibiotics_test_status = 'COMPLETED'
        AND an.test_result = 'FAIL'
        AND g.grn_date >= '2025-03-15'
        `
         query = query + `GROUP BY an.count`
  try {
    const Data = await manager.query(query);
    return new CommonResponse(true, 1001, ' data retrieved successfully', Data);
  } catch (error) {
    console.error("Database query error:", error);
    return new CommonResponse(false, 1002, 'Error retrieving  data', []);
  }
}

async getAllAntiBioticsFailedFarmer(): Promise<CommonResponse> {
    const manager = getManager();
  
    const query = `
      SELECT DISTINCT name FROM (
        SELECT s.name AS name
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer
        WHERE an.test_at IN ('GRADING', 'PRE HARVEST')
          AND an.antibiotics_test_status = 'COMPLETED'
          AND an.test_result = 'FAIL'
          AND g.grn_date >= '2025-03-15'
  
        UNION
  
        SELECT su.name AS name
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.broker
        WHERE an.test_at IN ('GRADING', 'PRE HARVEST')
          AND an.antibiotics_test_status = 'COMPLETED'
          AND an.test_result = 'FAIL'
          AND g.grn_date >= '2025-03-15'
      ) AS combined
      WHERE name IS NOT NULL
      ORDER BY name
    `;
  
    try {
      const Data = await manager.query(query);
      return new CommonResponse(true, 1001, 'Dropdown list retrieved successfully', Data);
    } catch (error) {
      console.error("Database query error:", error);
      return new CommonResponse(false, 1002, 'Error retrieving dropdown list', []);
    }
  }
  


async getAllAntiBioticsGradingData(req:AntibioticsReq): Promise<CommonResponse> {
    console.log(req,'11111')
    
    const manager = getManager();
    req = req || {};

        let query = `
        SELECT an.lot_number AS lotNumber,CASE WHEN gi.reweighment_count IS NOT NULL THEN gi.reweighment_count ELSE gi.count  
END AS count, CASE WHEN gi.reweighment_boxes IS NOT NULL THEN gi.reweighment_boxes ELSE gi.boxes  
END AS boxes,CASE WHEN gi.reweighment_quantity IS NOT NULL THEN gi.reweighment_quantity ELSE gi.quantity  
END AS HONQuantity,
               an.c_a_p AS cap, an.a_o_z AS aoz, an.a_m_o_z AS amoz, an.s_e_m AS sem, 
               an.a_h_d AS ahd, an.grn_item_id AS grnItemId,an.c_a_p_details as capValue,an.a_o_z_details as aozValue,an.a_m_o_z_details as amozValue, an.s_e_m_details AS semValue,an.a_h_d_details as ahdValue,ii.expected_qty as indentQuantity,gi.quantity AS grnQuantity,g.grn_id as grnId,
               an.test_result AS Result, g.grn_number AS grnNumber,g.grn_date as grnDate,
               i.indent_code AS indentNumber, an.alloted_lab AS allotedLab, i.indent_id as indentId,
               an.test_at AS testAt, an.location, an.remarks, s.name AS farmerName,su.name AS dealerName,
               an.sampler_name AS samplerName, an.test_status AS testStatus, 
               an.lab_name AS labName ,an.antibiotics_test_status as antibioticsTestStatus,i.supplier_type as supplierType
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id=gi.indent_item_id 
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer 
        LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.broker 

        WHERE an.test_at = 'GRADING'
        
        AND an.antibiotics_test_status IN ('COMPLETED', 'PROCESSING')
        
        `
        if (req.fromDate && req.toDate != undefined) {
            query += ` AND g.grn_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
        }
        
  else {
    query += ` AND g.grn_date >= '2025-03-15'`;
  }
  query +=`GROUP BY gi.grn_id,an.lot_number`
  try {
    const grnData = await manager.query(query, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : []);
    return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
  } catch (error) {
    console.error("Database query error:", error);
    return new CommonResponse(false, 1002, 'Error retrieving GRN data', []);
  }
}

async getAllAntiBioticsPreHarvestData(req: AntibioticsReq): Promise<CommonResponse> {
    const manager = getManager();
    req = req || {};
  
    let query = `
        SELECT an.infoId, an.lot_number AS lotNumber, an.count, an.no_of_boxes AS boxes, 
               gi.quantity AS grnQuantity,ii.expected_qty as indentQuantity,gi.reweighment_status as reweighmentStatus, an.c_a_p AS cap, an.a_o_z AS aoz, i.indent_id as indentId,
               an.a_m_o_z AS amoz, an.s_e_m AS sem, an.a_h_d AS ahd, an.grn_item_id AS grnItemId, 
               i.indent_date as indentDate, an.c_a_p_details AS capValue, an.a_o_z_details AS aozValue, 
               an.a_m_o_z_details AS amozValue, an.a_h_d_details AS ahdValue, i.supplier_type as supplierType,
               ms.name AS farmerName, msb.name AS supplierName, an.antibiotics_test_status AS antibioticsTestStatus, 
               an.s_e_m_details AS semValue, an.test_result AS Result, g.grn_number AS grnNumber, g.grn_date as grnDate,
               i.indent_code AS indentNumber, an.alloted_lab AS allotedLab, an.test_at AS testAt, 
               an.location, an.remarks, an.sampler_name AS samplerName, an.test_status AS testStatus, 
               an.lab_name AS labName
        FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id = gi.indent_item_id
        LEFT JOIN ${appSettings.masters_db}.suppliers ms ON ms.supplier_id = gi.farmer
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
        LEFT JOIN ${appSettings.masters_db}.suppliers msb ON msb.supplier_id = gi.farmer
        WHERE an.test_at = 'PRE HARVEST' 
          AND an.antibiotics_test_status IN ('COMPLETED', 'PROCESSING')
    `;
  
    const queryParams: any[] = [];
  
    // Safely handle fromDate and toDate using parameterized queries
    if (req.fromDate && req.toDate) {
      query += ` AND DATE(g.grn_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    //   queryParams.push(`${req.fromDate} 00:00:00`, `${req.toDate} 23:59:59`);
    } else {
      query += ` AND DATE(g.grn_date) >= '2025-03-15'`;
    //   queryParams.push('2025-03-15');
    }
  
    query += ` GROUP BY an.infoId ORDER BY an.infoId`;
  console.log("queryyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy",query);
    try {
      const data = await manager.query(query, queryParams);
      return new CommonResponse(true, 1001, 'Harvest data retrieved successfully', data);
    } catch (error) {
      console.error('Database query error:', error);
      return new CommonResponse(false, 1002, 'Error retrieving GRN data', []);
    }
  }
  
    

// async getAllAntiBioticsPreHarvestData(req:AntibioticsReq): Promise<CommonResponse> {
//     const manager = getManager();
//     req = req || {};
    
//         let query = `
//         SELECT  an.count as count , ii.expected_qty as quantity , an.infoId as infoId,
//         an.c_a_p AS cap, an.a_o_z AS aoz, an.a_m_o_z AS amoz, an.s_e_m AS sem, an.a_h_d AS ahd,
//         an.c_a_p_details AS capValue, an.a_o_z_details AS aozValue, an.a_m_o_z_details AS amozValue, an.a_h_d_details AS ahdValue, 
//         s.name AS farmerName,su.name AS dealerName, an.antibiotics_test_status AS antibioticsTestStatus, 
//         an.s_e_m_details AS semValue, an.test_result AS Result, i.indent_code AS indentNumber,i.indent_date as indentDate, an.indent_item_id as indentItemId,an.indent_id as indentId,
//         an.alloted_lab AS allotedLab, an.test_at AS testAt, an.location, an.remarks, an.sampler_name AS samplerName, 
//         an.test_status AS testStatus, an.lab_name AS labName,i.supplier_type as supplierType
//         FROM ${appSettings.rm_procure_db}.rm_antibiotics_info an  
//         LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = an.indent_id
//         LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_item_id = an.indent_item_id
//         LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = ii.farmer
//         LEFT JOIN erpx_dev_masters.suppliers su ON su.supplier_id = ii.broker
//         WHERE an.test_at = 'PRE HARVEST' AND an.antibiotics_test_status IN ('COMPLETED', 'PROCESSING') 
//         `;
//         if (req.fromDate && req.toDate != undefined) {
//             query += ` AND i.indent_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
//         }
//          else {
//     query += ` AND i.indent_date >= '2025-03-15'`;
//   }
//   query += ` GROUP BY an.infoId ORDER BY an.infoId`;
//   try {
//     const grnData = await manager.query(query, req.fromDate && req.toDate ? [req.fromDate, req.toDate] : []);
//     return new CommonResponse(true, 1001, 'GRN data retrieved successfully', grnData);
//   } catch (error) {
//     console.error("Database query error:", error);
//     return new CommonResponse(false, 1002, 'Error retrieving GRN data', []);
//   }
// }


async getAllAntiBioticsResult(req:AntibioticsReq):Promise<CommonResponse>{
    
    const manager = getManager()
    try{
        let query = `
        select an.lot_number as lotNumber,an.count,an.no_of_boxes as boxes,an.c_a_p as cap,an.a_o_z as aoz,an.a_m_o_z as amoz,an.s_e_m as sem,an.a_h_d as ahd,an.grn_item_id as grnItemId,
an.c_a_p_details as capValue,an.a_o_z_details as aozValue,an.a_m_o_z_details as amozValue,an.a_h_d_details as ahdValue,ms.name AS farmerName,msb.name AS supplierName,
an.s_e_m_details as semValue,an.test_result as Result,g.grn_number as grnNumber,i.indent_code as indentNumber,an.alloted_lab as allotedLab,an.test_at as testAt,an.location,an.remarks,an.sampler_name as samplerName,an.test_status as testStatus,an.lab_name as labName
from ${appSettings.rm_procure_db}.rm_antibiotics_info an
left join ${appSettings.rm_procure_db}.grn g on g.grn_id = an.grn_id
left join ${appSettings.rm_procure_db}.grn_items gi on gi.grn_item_id = an.grn_item_id
left join ${appSettings.masters_db}.suppliers ms ON ms.supplier_id=gi.farmer
left join  ${appSettings.rm_procure_db}.indent i on i.indent_id = g.indent_no
left join ${appSettings.masters_db}.suppliers msb ON msb.supplier_id=gi.farmer 
where 1=1
        `
        if (req.fromDate && req.toDate) {
            query += `AND an.created_at BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
        }
            

            if(req.indentNumber){
                query += ` And i.indent_code = '${req.indentNumber}'`
            }
            if(req.grnNumber){
                query += ` And g.grn_number = '${req.grnNumber}'`
            }
            if(req.lotNumber){
                query += ` And an.lot_number = '${req.lotNumber}'`
            }
            if(req.status){
                query += `AND an.test_result = '${req.status}'`
            }
            if(req.allotedLab){
                query += `AND an.alloted_lab = '${req.allotedLab}'`
            }
            if(req.testAt){
                query += `AND an.test_at = '${req.testAt}'`
            }
            const data = await manager.query(query)
            if(data.length> 0 ){
                return new CommonResponse(true,1,'Data retreived',data)
            }else {
              return new CommonResponse(false,0,'No data found')
            }
        
            }catch(error){
                throw error
            }
        
    }
}





